'use strict';

const ANNOTATION_LOCATION = "backstage.io/managed-by-location";
const ANNOTATION_ORIGIN_LOCATION = "backstage.io/managed-by-origin-location";
const ANNOTATION_SOURCE_LOCATION = "backstage.io/source-location";

exports.ANNOTATION_LOCATION = ANNOTATION_LOCATION;
exports.ANNOTATION_ORIGIN_LOCATION = ANNOTATION_ORIGIN_LOCATION;
exports.ANNOTATION_SOURCE_LOCATION = ANNOTATION_SOURCE_LOCATION;
//# sourceMappingURL=annotation.cjs.js.map
